import React from 'react';
import { Link } from 'react-router-dom';

const sb = { borderLeft:'3px solid var(--gold)', padding:'.75rem 1.5rem', background:'rgba(197,165,90,0.04)' };
const sbText = { fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'1.05rem', lineHeight:1.8, color:'rgba(245,240,232,0.92)', marginBottom:'.25rem' };
const sbRef = { fontFamily:"'Oswald',sans-serif", fontSize:'.8rem', letterSpacing:2, color:'var(--gold)' };

const MAIL_LINK = 'mailto:contact@freebiblesnow.org?subject=Free%20Bible%20Request%20(from%20KJVUSA.org)&body=Hi!%20I%27d%20like%20to%20request%20a%20free%20King%20James%20Bible.%0A%0AName:%20%0AAddress:%20%0ACity,%20State,%20Zip:%20';

export default function FreeBibles() {
  return (
    <>
      {/* HERO */}
      <section className="hero" style={{ background:'linear-gradient(165deg,var(--navy) 0%,var(--deep-blue) 40%,var(--royal) 100%)', minHeight:'auto', padding:'5rem 2rem 4rem' }}>
        <div className="inner" style={{ textAlign:'center' }}>
          <div className="section-label center">No Cost. No Catch. No Strings.</div>
          <h1 className="section-title" style={{ fontSize:'clamp(1.8rem,5vw,3.2rem)', marginBottom:'1.25rem', lineHeight:1.15 }}>
            Get a Free Bible
          </h1>
          <p style={{ fontSize:'1.1rem', fontFamily:"'Playfair Display',serif", fontStyle:'italic', color:'rgba(245,240,232,0.8)', maxWidth:600, margin:'0 auto 2rem' }}>
            Everyone deserves access to the Word of God. We will mail you a King James Bible, completely free of charge, anywhere in the United States.
          </p>
          <div style={{ ...sb, maxWidth:600, margin:'0 auto', textAlign:'left' }}>
            <p style={sbText}>"Freely ye have received, freely give."</p>
            <p style={sbRef}>Matthew 10:8</p>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* HOW IT WORKS */}
      <section style={{ background:'linear-gradient(180deg,var(--navy),var(--deep-blue))' }}>
        <div className="inner">
          <h2 className="section-title" style={{ fontSize:'clamp(1.4rem,3vw,2rem)' }}>How It Works</h2>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(250px,1fr))', gap:'1.5rem', marginTop:'.5rem' }}>
            <div style={{ textAlign:'center', padding:'2.5rem 2rem', background:'rgba(197,165,90,0.04)', border:'1px solid rgba(197,165,90,0.12)' }}>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'3rem', color:'var(--gold)', opacity:.5, marginBottom:'.5rem' }}>1</div>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.2rem', color:'var(--white)', marginBottom:'.75rem' }}>Request a Bible</h3>
              <p style={{ fontSize:'.9rem', lineHeight:1.8, color:'rgba(245,240,232,0.75)' }}>Click the button below. Send us your name and mailing address. That is all we need.</p>
            </div>
            <div style={{ textAlign:'center', padding:'2.5rem 2rem', background:'rgba(197,165,90,0.04)', border:'1px solid rgba(197,165,90,0.12)' }}>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'3rem', color:'var(--gold)', opacity:.5, marginBottom:'.5rem' }}>2</div>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.2rem', color:'var(--white)', marginBottom:'.75rem' }}>We Mail It Free</h3>
              <p style={{ fontSize:'.9rem', lineHeight:1.8, color:'rgba(245,240,232,0.75)' }}>We will send a Bible to your door. There is no charge for the Bible or for shipping. It is a gift.</p>
            </div>
            <div style={{ textAlign:'center', padding:'2.5rem 2rem', background:'rgba(197,165,90,0.04)', border:'1px solid rgba(197,165,90,0.12)' }}>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'3rem', color:'var(--gold)', opacity:.5, marginBottom:'.5rem' }}>3</div>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.2rem', color:'var(--white)', marginBottom:'.75rem' }}>Read It</h3>
              <p style={{ fontSize:'.9rem', lineHeight:1.8, color:'rgba(245,240,232,0.75)' }}>We recommend starting with the Gospel of John. It was written so that "ye might believe that Jesus is the Christ, the Son of God" (John 20:31).</p>
            </div>
          </div>
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* CTA - REQUEST */}
      <section style={{ background:'var(--deep-blue)', textAlign:'center' }}>
        <div className="inner" style={{ maxWidth:650 }}>
          <div style={{ fontSize:'3rem', marginBottom:'1rem' }}>📖</div>
          <h2 className="section-title" style={{ fontSize:'clamp(1.5rem,3.5vw,2.2rem)', marginBottom:'1rem' }}>
            Request Your Free Bible
          </h2>
          <p style={{ fontSize:'1rem', lineHeight:1.9, color:'rgba(245,240,232,0.75)', marginBottom:'2rem' }}>
            Click the button below to send an email with your name and mailing address. We will get a Bible in the mail to you as soon as possible. There is absolutely no cost, no follow-up sales, and no obligation. The Word of God should be free.
          </p>
          <a href={MAIL_LINK} className="btn-p" style={{ fontSize:'1rem', padding:'1rem 3rem', display:'inline-block', textDecoration:'none' }}>
            Request a Free Bible
          </a>
          <p style={{ fontSize:'.8rem', color:'rgba(245,240,232,0.4)', marginTop:'1.5rem' }}>
            Opens your email app. Simply fill in your name and address, then hit send.
          </p>
        </div>
      </section>

      <div className="divider" />

      {/* ALREADY HAVE A BIBLE */}
      <section style={{ background:'linear-gradient(180deg,var(--navy),var(--deep-blue))' }}>
        <div className="inner" style={{ maxWidth:700 }}>
          <h2 className="section-title" style={{ fontSize:'clamp(1.3rem,3vw,1.8rem)' }}>Already Have a Bible?</h2>
          <div className="about-content">
            <p>If you already have a Bible, the most important thing you can do is read it. We recommend starting with the Gospel of John, which you can read right now on this site.</p>
            <p>If you have never trusted Jesus Christ as your personal Saviour, we invite you to read our "How to Be Saved" page. The Bible makes the way of salvation plain, and it is the most important decision you will ever make.</p>
          </div>
          <div style={{ display:'flex', gap:'1.5rem', justifyContent:'center', flexWrap:'wrap', marginTop:'2rem' }}>
            <Link to="/bible/43/1" className="btn-p">Read the Gospel of John</Link>
            <Link to="/salvation" className="btn-s">How to Be Saved</Link>
          </div>
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* ABOUT THE MINISTRY */}
      <section style={{ background:'var(--deep-blue)' }}>
        <div className="inner" style={{ maxWidth:700 }}>
          <h2 className="section-title" style={{ fontSize:'clamp(1.3rem,3vw,1.8rem)' }}>About Free Bibles Now</h2>
          <div className="about-content">
            <p>This free Bible ministry is operated through <strong>Free Bibles Now</strong>, a Bible-giving ministry dedicated to putting the Word of God into the hands of every person who wants one.</p>
            <p>Free Bibles Now sets up tents and tables in communities across the country to hand out free Bibles, offer prayer, and tell people about the Lord Jesus Christ. They also mail free Bibles to anyone who requests one.</p>
            <p>If you would like to learn more about the ministry, feel free to visit the website.</p>
          </div>
          <div style={{ textAlign:'center', marginTop:'2rem' }}>
            <a href="https://www.freebiblesnow.org/" target="_blank" rel="noopener noreferrer" className="btn-s" style={{ textDecoration:'none' }}>
              Visit FreeBiblesNow.org
            </a>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* CLOSING */}
      <section style={{ background:'linear-gradient(165deg,#1B3A6B 0%,var(--deep-blue) 50%,var(--navy) 100%)', textAlign:'center', padding:'4rem 2rem' }}>
        <div className="inner" style={{ maxWidth:600 }}>
          <div style={{ ...sb, textAlign:'left', margin:'0 auto 2rem' }}>
            <p style={sbText}>"So then faith cometh by hearing, and hearing by the word of God."</p>
            <p style={sbRef}>Romans 10:17</p>
          </div>
        </div>
      </section>
    </>
  );
}
